/** Cotizador movil solo-crea: compone un requerimiento nuevo (design.md §22.5).
 *
 * Sin modo vincular ni `customer_requirement_id`: el cotizador siempre crea
 * un requerimiento nuevo (nombre y fecha requerida). La descripcion pertenece
 * al alta y edicion del requerimiento, no al cotizador.
 * Replica el contrato `POST /api/v1/commercial/requirement-compositions`
 * (extra=forbid): sin cliente no se compone.
 */
import * as yup from 'yup';

function todayIso(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const quoteLinesSchema = yup.object({
  lines: yup
    .array()
    .of(
      yup.object({
        master_item_id: yup.string().required(),
        quantity: yup.number().required().moreThan(0, 'La cantidad debe ser positiva'),
      }),
    )
    .required()
    .min(1, 'Agrega al menos una partida'),
});

export type QuoteLines = yup.InferType<typeof quoteLinesSchema>;

const quoteLineShape = yup.object({
  master_item_id: yup.string().required(),
  quantity: yup.number().required().moreThan(0, 'La cantidad debe ser positiva'),
});

export const mobileQuoteGeneratorSchema = yup.object({
  client_id: yup.string().required('El cliente es obligatorio'),
  new_requirement_name: yup
    .string()
    .required('El nombre es obligatorio')
    .trim()
    .min(2, 'El nombre es muy corto')
    .max(255, 'El nombre es muy largo'),
  new_requirement_required_date: yup
    .string()
    .required('La fecha requerida es obligatoria')
    .test('no-pasada', 'La fecha no puede ser anterior a hoy', (value) => {
      if (!value) return false;
      return value >= todayIso();
    }),
  lines: yup
    .array()
    .of(quoteLineShape)
    .required('Agrega al menos una partida')
    .min(1, 'Agrega al menos una partida'),
  discount_percent: yup.number().min(0, 'El descuento no puede ser negativo').max(100, 'El descuento no supera 100').default(0),
  discount_reason: yup.string().when('discount_percent', {
    is: (value: unknown) => typeof value === 'number' && value > 0,
    then: (schema) =>
      schema
        .required('El motivo es obligatorio cuando hay descuento')
        .trim()
        .min(3, 'El motivo es muy corto')
        .max(2000, 'El motivo es muy largo'),
    otherwise: (schema) => schema.default(''),
  }),
});

export type MobileQuoteGeneratorForm = yup.InferType<typeof mobileQuoteGeneratorSchema>;
